import Button, { ButtonProps } from "@mui/material/Button";

import classNames from "classnames";

export interface Props extends ButtonProps {
  children?: React.ReactNode;
  className?: string;
}
function OurButton(props: Readonly<Props>) {
  const { children, className, ...otherProps } = props;
  return (
    <Button
      className={classNames([className, "sebkort-brand-button"])}
      data-adobe-eventname="interaction"
      data-adobe-eventcategory="contact"
      {...otherProps}
    >
      {children}
    </Button>
  );
}

export default OurButton;
